<div class="mt-8 mb-4">
    <div class="flex justify-between items-center w-full mb-4">
        <div class="flex flex-row justify-between">
            <app-btn-back></app-btn-back>
        </div>
    </div>

    @if (session(); as s) {
    <div class="flex flex-col mb-4 border-0 w-full">
        <div class="flex flex-row justify-between">
            <div class="flex flex-col">
                <h1 class="font-semibold text-2xl text-primary-500">
                    Live Quiz Room
                </h1>
                <span class="text-sm text-gray-500">
                    {{ s.status === quizStatus.waiting ? 'Waiting for participants. Start Quiz at any time' :
                    s.status === quizStatus.inProgress ? 'Session is in progress' : s.status === quizStatus.completed ?
                    'Session has ended' :'' }}
                </span>
            </div>
            <div class="flex flex-col justify-end items-end">
                <span class="text-primary-300 mr-2">Room Code</span>
                <div class="flex flex-row gap-2 items-center justify-end">
                    <span class="text-primary-500 font-bold text-2xl">{{ quiz?.inviteCode }}</span>
                    <app-btn-fab icon="fa fa-copy" bgColor="bg-transparent hover:bg-white active:bg-gray-300"
                        (click)="copyInviteCode()"></app-btn-fab>
                </div>
            </div>
        </div>

        <div class="flex flex-col bg-white rounded-lg justify-start items-start p-4 mt-4">
            <div class="flex flex-row justify-between items-center w-full">
                <div class="flex flex-col">
                    <span class="text-lg font-semibold text-primary-500">Quiz Session</span>
                    <div class="h-6 overflow-hidden">
                        @if(s.status === quizStatus.waiting || s.currentIndex === -1) {
                        <span class="block text-sm text-primary-300 animate-fade-in-up">
                            Participants can join during active quiz session by using Invite Code.
                        </span>
                        } @else if (s.status === quizStatus.inProgress) {
                        <span class="block text-sm text-primary-300 animate-fade-in-up">
                            Question {{ s.currentIndex + 1 }} of {{ s.displayTotal || quiz?.questions?.length }}
                        </span>
                        }
                    </div>
                </div>
                <div class="flex flex-row gap-2">
                    @if (s.currentIndex === -1) {
                    <app-btn-action icon="fa fa-play" textColor="text-primary-500 hover:text-white" [shadow]="false"
                        textStyle="font-medium text-sm titlecase" bgColor="bg-gray-200 hover:bg-primary-700"
                        label="Start Quiz" (click)="startQuiz()"></app-btn-action>
                    } @else if (s.status === quizStatus.inProgress) {
                    <app-btn-action icon="fa fa-stop" textColor="text-primary-500 hover:text-white" [shadow]="false"
                        textStyle="font-medium text-sm titlecase" bgColor="bg-gray-200 hover:bg-red-500"
                        label="End Quiz" (click)="endQuiz()"></app-btn-action>
                    <app-btn-action suffixIcon="fa fa-chevron-right" textColor="text-primary-500 hover:text-white"
                        [shadow]="false" textStyle="font-medium text-sm titlecase"
                        bgColor="bg-gray-200 hover:bg-primary-700" label="Next Question"
                        (click)="nextQuestion()"></app-btn-action>
                    }
                </div>
            </div>

            @if (s.currentIndex === -1 || s.status === quizStatus.waiting) {
            <div class="flex flex-col gap-4 mt-4 w-full">
                <div class="flex flex-row justify-between p-4 bg-blue-100 rounded-lg gap-4 w-full">
                    <div class="flex flex-row items-center gap-4">
                        <i class="fa fa-users text-secondary-500 text-xl"></i>
                        <div class="flex flex-col justify-start">
                            <span class="text-md font-semibold text-primary-500">
                                {{ (onlineStudents$ | async)?.length || 0 }} Students Joined
                            </span>
                            <span class="text-sm text-primary-300">Share the room code</span>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                    @for (student of onlineStudents$ | async; track student.id) {
                    <div class="p-2 bg-white border border-gray-200 rounded shadow-sm flex items-center gap-2 w-full">
                        <div class="w-2 h-2 rounded-full bg-green-500"></div>
                        <span class="text-sm font-medium text-gray-700">{{ student.name }}</span>
                    </div>
                    } @empty {
                    <div class="col-span-full text-center py-8 text-gray-400 italic">
                        Waiting for the first student to join...
                    </div>
                    }
                </div>
            </div>
            }

            @else if (s.status === quizStatus.inProgress) {
            <div class="flex flex-col gap-4 mt-4 w-full">
                <div class="flex flex-row gap-4 min-h-32 rounded-lg bg-white border-gray-100">
                    <div class="flex flex-col grow-1 justify-between rounded-md bg-gray-100 p-4 border-gray-200 w-full">
                        <div class="flex flex-row items-center">
                            <i class="fa fa-users text-secondary-500 text-sm"></i>
                            <span class="text-sm text-primary-300 ml-2">Participants</span>
                        </div>
                        <div class="flex flex-col items-end">
                            <span class="text-3xl font-bold text-primary-500">{{ (onlineStudents$ | async)?.length || 0
                                }}</span>
                            <span class="text-xs text-primary-300">Total Participants</span>
                        </div>
                    </div>

                    <div class="flex flex-col justify-between rounded-md grow-1 w-full bg-gray-100 border-gray-200 p-4">
                        <div class="flex flex-row items-center">
                            <i class="fa fa-clock text-secondary-500 text-sm"></i>
                            <span class="text-sm text-primary-300 ml-2">Time Remaining</span>
                        </div>
                        <div class="flex flex-col items-end">
                            <span class="text-3xl font-bold transition-colors duration-300"
                                [class.text-red-600]="remainingTime() === 0"
                                [class.text-red-500]="remainingTime() > 0 && remainingTime() <= 5"
                                [class.text-primary-500]="remainingTime() > 5"
                                [class.animate-pulse]="remainingTime() > 0 && remainingTime() <= 5">
                                {{ remainingTime() }}
                            </span>
                            <span class="text-xs text-primary-300">Seconds Remaining</span>
                        </div>
                    </div>
                </div>

                <div class="bg-gray-100 p-4 rounded-lg border border-gray-200">
                    <div class="flex flex-col justify-start items-start gap-4 w-full">
                        <div class="flex flex-row items-center">
                            <i class="fa fa-list text-secondary-500 text-sm"></i>
                            <span class="text-sm text-primary-300 ml-2">Live Submissions</span>
                        </div>

                        <table class="w-full text-sm border-collapse border border-gray-200 bg-white">
                            <thead class="bg-gray-50 text-gray-500 uppercase text-xs">
                                <tr>
                                    <th class="p-3 text-left">Rank</th>
                                    <th class="p-3 text-left">Student</th>
                                    <th class="p-3 text-left">Answer</th>
                                    <th class="p-3 text-center">Status</th>
                                    <th class="p-3 text-left">Time</th>
                                    <th class="p-3 text-left">Score</th>
                                    <th class="p-3 text-center">Host Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (response of (responses$ | async); track response.studentId; let i = $index) {
                                <tr class="border-b border-gray-100 hover:bg-gray-50 transition-colors"
                                    [class.bg-green-50]="response.isCorrect === true"
                                    [class.bg-red-50]="response.isCorrect === false"
                                    [class.bg-yellow-50]="response.isCorrect === null || response.isCorrect === undefined">

                                    <td class="p-3 font-bold text-gray-400">#{{ i + 1 }}</td>
                                    <td class="p-3 font-medium">{{ response.studentName }}</td>
                                    <td class="p-3 italic">"{{ response.studentAnswer }}"</td>

                                    <td class="p-3 text-center">
                                        @if (response.isCorrect === true) {
                                        <i class="fa fa-check-circle text-green-500 text-lg" title="Correct"></i>
                                        } @else if (response.isCorrect === false) {
                                        <i class="fa fa-times-circle text-red-500 text-lg" title="Incorrect"></i>
                                        } @else {
                                        <div class="flex flex-col items-center">
                                            <i class="fa fa-clock text-yellow-500 animate-pulse"></i>
                                            <span class="text-[10px] text-yellow-600 font-bold uppercase">Pending</span>
                                        </div>
                                        }
                                    </td>

                                    <td class="p-3 text-gray-500">{{ response.timeTaken }}s</td>
                                    <td class="p-3 font-bold text-primary-500">{{ response.score }}</td>

                                    <td class="p-3 text-center">
                                        <div class="flex justify-center gap-2">
                                            <button (click)="gradeResponse(response, true)"
                                                class="p-2 w-8 h-8 flex items-center justify-center bg-green-500 text-white hover:text-primary-500 rounded-md transition-all shadow-sm"
                                                title="Mark Correct">
                                                <i class="fa fa-check text-xs"></i>
                                            </button>

                                            <button (click)="gradeResponse(response, false)"
                                                class="p-2 w-8 h-8 flex items-center justify-center bg-red-500 text-white hover:text-primary-500 rounded-md transition-all shadow-sm"
                                                title="Mark Incorrect">
                                                <i class="fa fa-times text-xs"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                } @empty {
                                <tr>
                                    <td colspan="7" class="text-center py-10 text-gray-400 italic font-light">
                                        <div class="flex flex-col items-center gap-2">
                                            <i class="fa fa-inbox text-2xl opacity-20"></i>
                                            <span>Waiting for student responses...</span>
                                        </div>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                @let q = currentQuestion();
                @if(q) {
                <div class="bg-white w-full rounded-lg border border-gray-200 p-4 mb-2">
                    <div class="flex flex-row items-center mb-4">
                        <i class="fa fa-question-circle text-primary-300 text-sm"></i>
                        <span class="text-sm text-primary-300 ml-2">Current Question Card</span>
                    </div>
                    <app-question-view [q]="q" [isEditable]="false"></app-question-view>
                </div>
                }
            </div>
            }

            @else if (s.status === quizStatus.completed) {
            <div class="flex flex-col items-center justify-center py-12 w-full text-center">
                <div class="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4">
                    <i class="fa fa-trophy text-4xl"></i>
                </div>
                <h2 class="text-2xl font-bold text-primary-500">Quiz Completed!</h2>
                <p class="text-gray-500 mt-2">The results are ready.</p>
                <div class="mt-4 flex gap-4">
                    <app-btn-action label="Back to Dashboard"
                        (click)="router.navigate(['/school', groupId, 'quizzes'])"></app-btn-action>
                </div>
            </div>
            }
        </div>
    </div>
    } @else {
    <div class="flex flex-col items-center justify-center py-20 text-gray-400">
        <i class="fa fa-circle-notch fa-spin text-3xl mb-4"></i>
        <p>Connecting to session...</p>
    </div>
    }
</div>